// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2VX71","form":"styles_form__1-Oii"};